'use client';

import { useSession } from 'next-auth/react';
import { useTenant } from '@/contexts/TenantContext';
import { useMemo } from 'react';

export function useAuth() {
  const { data: session, status } = useSession();
  const { selectedTenant } = useTenant();

  const roles = useMemo(() => {
    if (!session || !selectedTenant) {
      return session?.user?.roles || [];
    }

    const tenantRolesMap = session.tenantRolesMap;
    if (tenantRolesMap && tenantRolesMap[selectedTenant]) {
      return tenantRolesMap[selectedTenant];
    }

    return session?.user?.roles || [];
  }, [session, selectedTenant]);

  return {
    user: session?.user,
    roles,
    isAuthenticated: status === 'authenticated',
    isLoading: status === 'loading',
    session,
  };
}

export function useHasRole(role: string) {
  const { roles } = useAuth();
  return roles.includes(role);
}

export function useHasAnyRole(requiredRoles: string[]) {
  const { roles } = useAuth();
  return requiredRoles.some((role) => roles.includes(role));
}
